var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-detail membership blank" }, [
      _c("h2", { staticClass: "label-middle-title" }, [
        _vm._v("멤버십 / 구독 및 결제 관리")
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "label-small-description description",
          staticStyle: { marginBottom: "20px" }
        },
        [
          _vm._v(
            "실리콘밸리의 생생한 인사이트를 전하는 앞서가는 사람들의 테크 & 경제 미디어, 더밀크 멤버십을 이용해보세요."
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "membership-container expiration-date" }, [
        _c("div", { staticClass: "info-wrapper" }, [
          _c("h3", { staticClass: "label-middle-description bold point" }, [
            _vm._v("구독 플랜")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "label-small-description description" }, [
            _vm._v("무료 구독 플랜")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-wrapper" }, [
          _c(
            "a",
            {
              staticClass: "button button-bordered no-deco",
              attrs: { href: "/orders/plans" }
            },
            [_vm._v("\n        플랜 변경하기\n      ")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }